import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { TiVoDeviceClientType } from "./types";

export const useClientType = (
  platformId?: string,
  oemId?: string,
  clientTypeId?: string
) => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<TiVoDeviceClientType>>({
    queryKey: ["clientType", platformId, oemId, clientTypeId],
    queryFn: async () =>
      dispatch(
        apiThatThrows.getTiVoClientType.action({
          params: { oemId, platformId, clientTypeId },
        })
      ),
    enabled: Boolean(oemId) && Boolean(platformId) && Boolean(clientTypeId),
  });
};
